import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Summer from '../../component/Summer/Main_Summer';
import Save_Date from '../../component/Save_Date';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import CallInfo from '../../component/CallInfo';
import Information from '../../component/Information';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import AccountList2 from '../../component/Account/AccountList2';


const OhHyunJoo = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "동환 ♥ 현주 결혼식으로 초대합니다.";
    const openDesc = "2025년 7월 5일 16시10분 포시즌앤강남";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/207/thumb1.jpg";

    const lng = 127.052914072356;
    const lat = 37.489109180937;

    const placeTelNum = "02-2190-2271";

    const forParking = "공우이엔씨 건물 주차장 이용 - 주차 3시간 무료"
    const forSubway = "3호선 ㆍ 분당선 '도곡역' 4번 출구 (도보 5분)"
    const forBus = "군인공제회관 버스정류장 ( NO. 23- 327)\n[일반] 11-3, 917\n[직행] 9414\n[간선] 402, N37\n[지선] 2413, 3012, 4319, 6411";

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });


    const conceptStyle = {
        // summer 블루
        concept: "SUMMER",
        titleColor: "#505D89",
        pointColor: "#505D89",
        btnBgColor: "#505D89",
        fontColor: "#ffffff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F5F8FF",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const title = "우리 결혼합니다.";

    const msg1 = "초록이 짙어지는 한여름의 어느 날,\n\n파란 하늘과 초록의 싱그러움 속에서\n한여름의 태양처럼 뜨겁게 사랑하며,\n서로의 반짝이는 여름이 되고자 합니다."
    const msg2 = "푸른 하늘처럼 넓은 마음으로\n서로를 아끼며 살아가겠습니다."
    const msg3 = "여러분의 뜨거운 축복 속에서,\n앞으로 함께 나아갈\n우리의 첫 여정을 함께해 주세요."


    const parents = [
        {groom : "❁박금주 · 이윤실의 장남"},
        {bride : "이학두 · 최경숙의 차녀"}
    ]

    const groomAccountList = [
        {
            role: "신랑",
            name: "유동환",
            bank: "카카오뱅크",
            accountNumber : "3333-26-0001377",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej7mTX4Wm"
        }
        // ,{
        //     role: "신랑 부·모",
        //     name: "김유겸",
        //     bank: "농협은행",
        //     accountNumber : "531142-52-048161",
        //     isKakao : false
        // }
        // ,{
        //     role: "신랑",
        //     name: "김찬주",
        //     bank: "농협은행",
        //     accountNumber : "356-0245-3851-13",
        //     isKakao : false
        // }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "오현주",
            bank: "국민은행",
            accountNumber : "490102-04-174647",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej7j4czsp"
        }
        // ,{
        //     role: "신부 부·모",
        //     name: "김성환",
        //     bank: "농협은행",
        //     accountNumber : "238-02-183195",
        //     isKakao : false
        // }
        // ,{
        //     role: "신부",
        //     name: "배다민",
        //     bank: "농협은행",
        //     accountNumber : "352-1043-7794-53",
        //     isKakao : true,
        //     kakaoUrl : "https://qr.kakaopay.com/Ej7nwOd76"
        // }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "서로의 첫 인상은 어땠어?",
            groomAnswer: "궁금했었어",
            brideAnswer: "왜 잘해주지"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "설렘 대폭발",
            brideAnswer: "긴장과 떨림"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "넌 나의 반쪽",
            brideAnswer: "너만 믿을게"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "와이프 바보",
            brideAnswer: "나의 0순위"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "나만 따라와",
            brideAnswer: "나만 믿고 와"
        },
    ]
    
    const groomCallInfoList = [
        {
            role: "신랑",
            name: "유동환",
            call: "010-5337 -5362"
        }
        ,{
            role: "신랑 부",
            name: "유광희",
            call: "010-2202-5362"
        }
        ,{
            role: "신랑 모",
            name: "박미진",
            call: "010-2256-1536"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "오현주",
            call: "010-5047-7375"
        }
        ,{
            role: "신부 부",
            name: "오용섭",
            call: "010-9048-7375"
        }
        ,{
            role: "신부 모",
            name: "송선숙",
            call: "010-6325-8479"
        }
    ]

    const informationList =[
        {
            title : "ATM 기기 안내",
            content : "주변엔 ATM기기가 없습니다. \n이점 양해 부탁드립니다."
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // ex. Kim Gayeong
    const getRemoveSpaceName = (fullName) => {
        const nameParts = fullName.split(' '); // 문자열을 띄어쓰기로 분리
        const firstName = nameParts[0]; // 첫 번째 단어 유지
        const restName = nameParts.slice(1).join(''); // 나머지 단어를 소문자로 변경하고 결합
        return firstName + ' ' + restName.charAt(0).toUpperCase() + restName.slice(1).toLowerCase();
    };

        // 성을 제외하고 이름만 추출 ex.Gayeong
        const getFirstEnName = (fullName) => {
            const nameParts = fullName.split(' '); 
            const firstName = nameParts.slice(1).join(''); 
            return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
        };
        
        // 브라운 #5b0100
        // #761B40
        // #423866
        // #d98db9
        // #FF8A83
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#505D89"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Summer weddingData={weddingData} groomNameEn={getRemoveSpaceName(weddingData.groomNameEn)} brideNameEn={getRemoveSpaceName(weddingData.brideNameEn)} color={"#505D89"} letteringFontColor={"#ffffff"} dateColor={"#ffffff"} bottom={"25%"} bottom2={"15.5%"} dateBottom={"1%"} top={"1%"}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={true} marginTop={"100px"} marginBottom={"10px"} fontSize={"13px"} />
                    <Info_Spring2 weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle} />
                    <CallInfo marginTop={"25px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring brideName={getFirstKoName(weddingData.groomName)} groomName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList2 conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    {/* <Information conceptStyle={conceptStyle} informationList={informationList} /> */}
                    <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} />
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc isPoint={true} forParking={forParking} forSubway={forSubway} forBus={forBus} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default OhHyunJoo;